const data = [
    {
        roles:[
            "Service Request Management",
            "Field Service",
            "Service Parts Management",
            "Contracts, Warranties ",
            "Service Monetization"
        ],
        title: "Essential Strategies for Field Service Management",
        description: "To give customers the service call experiences they expect, your systems must work together. Download this guide to learn how to build a strategically and tactically complete field service management system.",
        image: "tbnail01.png",
        cta_text:"Get the guide",
        url:"https://www.oracle.com/cx/service/field-service-management/connected-field-service/"
    },
    {
        roles:[
            "Service Request Management",
            "Field Service",
            "Service Parts Management",
            "Contracts, Warranties ",
            "Service Monetization"
        ],
        title: "Three Key Ingredients for Outcome-based Service Excellence",
        description: "Explore the strategies and technologies service organizations are implementing as they pivot to new economic models and position their businesses for long-term growth.",
        image: "tbnail02.png",
        cta_text:"Read the eBook",
        url:"https://www.oracle.com/a/ocom/docs/three-key-ingredients-outcome-based-service.pdf"
    }
]

export default data;